import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";


//GET v1/kontroledge/reports
//This function returns all reports
export function getReports(token: string, tenantId: number){
	return axios.get(`${API_URL}/v1/kontroledge/reports?tenantId=${tenantId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//GET /v1/kontroledge/reports/${reportId}/download
//This function returns all reports
export function downloadReports(token: string, reportId: number, tenantId: number){
	return axios.get(`${API_URL}/v1/kontroledge/reports/${reportId}/download?tenantId=${tenantId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}